if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              var element = document.querySelector('.product-form');
              if (element && element.getAttribute('open-popup') === "true") {
                // const quickViewModal = document.querySelector('.quick-view-modal');
                const modal = document.getElementById("quickViewModal");
                const AddToCartMg = document.querySelector('.added-to-cart-msg');
                const howToInstall = document.getElementById('how-to-install');
                const AddToCartMgClose = document.querySelector('.added-to-cart-msg-close');
                modal.style.display = 'block';
                AddToCartMg.style.display = 'flex';
                AddToCartMgClose.style.display = 'block';
                howToInstall.style.display = 'block';
                // Function to update cart count (optional)
                // function updateCartCount() {
                  $.getJSON('/cart.js', function(cart) {
                    // Update the cart count inside the element with id "cart-icon-bubble"
                    $('#cart-icon-bubble').html(`
                    <svg class="icon icon-cart" aria-hidden="true" focusable="false" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.1421 4.84486L6.00913 16.9805C6.02271 17.0807 6.05113 17.1762 6.0921 17.2646C6.21543 17.5309 6.45246 17.7338 6.74088 17.811C6.82899 17.8347 6.92133 17.8465 7.01578 17.8449H18C18.4416 17.8449 18.8309 17.5552 18.9578 17.1322L21.9578 7.13221C22.0487 6.82944 21.991 6.50154 21.8023 6.24793C21.6136 5.99432 21.3161 5.84486 21 5.84486H6.31948L5.99058 3.70706C5.97826 3.61767 5.95413 3.53206 5.91981 3.45184C5.85751 3.30577 5.76213 3.17924 5.64429 3.08006C5.53497 2.98786 5.40561 2.91869 5.26367 2.87999C5.17434 2.85553 5.0806 2.84327 4.9847 2.84486H3C2.44772 2.84486 2 3.29258 2 3.84486C2 4.39715 2.44772 4.84486 3 4.84486H4.1421ZM7.85794 15.8449L6.62717 7.84486H19.656L17.256 15.8449H7.85794Z" fill="currentColor"></path>
                      <path d="M10 20.8449C10 21.9494 9.10457 22.8449 8 22.8449C6.89543 22.8449 6 21.9494 6 20.8449C6 19.7403 6.89543 18.8449 8 18.8449C9.10457 18.8449 10 19.7403 10 20.8449Z" fill="currentColor"></path>
                      <path d="M19 20.8449C19 21.9494 18.1046 22.8449 17 22.8449C15.8954 22.8449 15 21.9494 15 20.8449C15 19.7403 15.8954 18.8449 17 18.8449C18.1046 18.8449 19 19.7403 19 20.8449Z" fill="currentColor"></path>
                    </svg>
                    <span class="visually-hidden">Cart</span>
                    <div class="cart-count-bubble">
                      <span aria-hidden="true">${cart.item_count}</span>
                      <span class="visually-hidden">${cart.item_count} item</span>
                    </div>
                    `);
                  });
                 // }
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
